import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

import { AuthLayout } from "~/components/layouts/AuthLayout";
import { CasePage } from "~/pages/CasePage";
import { CasesPage } from "~/pages/CasesPage";
import { LoginPage } from "~/pages/LoginPage";
import { OrgSelectionPage } from "~/pages/OrgSelectionPage";
import { RegisterPage } from "~/pages/RegisterPage";
import { RootPage } from "~/pages/RootPage";
import { SkyViewPage } from "~/pages/SkyViewPage";
import { TranscribingPage } from "~/pages/transcribing/TranscribingPage";
import { SettingsReports } from "./features/settings/components/reports";
import { SettingsAccount } from "./features/settings/components/SettingsAccount";
import { SettingsAnalytics } from "./features/settings/components/SettingsAnalytics";
import { SettingsAppearance } from "./features/settings/components/SettingsAppearance";
import { SettingsArchived } from "./features/settings/components/SettingsArchive";
import { SettingsCategories } from "./features/settings/components/SettingsCategories";
import { SettingsDevelopers } from "./features/settings/components/SettingsDevelopers";
import { SettingsKnowledge } from "./features/settings/components/SettingsKnowledge";
import { SettingsOrganization } from "./features/settings/components/SettingsOrganization";
import { SettingsPlanAndUsage } from "./features/settings/components/SettingsPlanAndUsage";
import { SettingsTeam } from "./features/settings/components/SettingsTeam";
import { ChangePasswordPage } from "./pages/ChangePasswordPage";
import { ScribeButtonDemo } from "./pages/dev/ScribeButtonDemo";
import { TestLimitReachedPage } from "./pages/dev/TestLimitReachedPage";
// import { DemoCaseGenerationPage } from "./pages/demoCase/DemoCaseGenerationPage";
// import { DemoCaseUploadPage } from "./pages/demoCase/DemoCaseUploadPage";
import { AuthCallbackPage } from "./pages/auth/AuthCallbackPage";
import { RegisterFinishPage } from "./pages/auth/RegisterFinishPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { ImpersonatePage } from "./pages/ImpersonatePage";
import { PaymentSuccessPage } from "./pages/PaymentSuccessPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { SettingsPage } from "./pages/SettingsPage";
import { ShareAccessDeniedPage } from "./pages/ShareAccessDeniedPage";
import { SharePage } from "./pages/SharePage";

import { AppLayout } from "./components/layouts/AppLayout";
import { logCurrentStage } from "./lib/utils";

logCurrentStage();

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <RootPage />,
      },
      {
        path: "/select-org",
        element: <OrgSelectionPage />,
      },
      // {
      //   path: "/organizations/:organizationId/demo-case-generation",
      //   element: <DemoCaseGenerationPage />,
      // },
      // {
      //   path: "/organizations/:organizationId/cases/:caseId/demo-case-generation",
      //   element: <DemoCaseUploadPage />,
      // },
      {
        path: "/organizations/:organizationId/cases",
        element: <CasesPage />,
      },
      {
        path: "/organizations/:organizationId/cases/:caseId",
        element: <CasePage />,
      },
      {
        path: "/organizations/:organizationId/cases/:caseId/chat/:chatId",
        element: <SkyViewPage />,
      },
      {
        path: "/organizations/:organizationId/settings",
        element: <SettingsPage />,
        children: [
          {
            path: "account",
            element: <SettingsAccount />,
          },
          {
            path: "appearance",
            element: <SettingsAppearance />,
          },
          {
            path: "organization",
            element: <SettingsOrganization />,
          },
          {
            path: "team",
            element: <SettingsTeam />,
          },
          {
            path: "categoriesManagement",
            element: <SettingsCategories />,
          },
          {
            path: "knowledge",
            element: <SettingsKnowledge />,
          },
          {
            path: "planAndUsage",
            element: <SettingsPlanAndUsage />,
          },
          {
            path: "analytics",
            element: <SettingsAnalytics />,
          },
          {
            path: "archived",
            element: <SettingsArchived />,
          },
          {
            path: "reports",
            element: <SettingsReports />,
          },
          {
            path: "developers",
            element: <SettingsDevelopers />,
          },
          {
            path: "usage",
            element: <Navigate to="../planAndUsage" replace />,
          },
          {
            path: "billing",
            element: <Navigate to="../planAndUsage" replace />,
          },
          {
            path: "productivity",
            element: <Navigate to="../analytics" replace />,
          },
        ],
      },
      {
        path: "/billing/success",
        element: <PaymentSuccessPage />,
      },
    ],
  },
  {
    element: <AuthLayout />,
    children: [
      {
        path: "/",
        element: <Navigate to="/login" />,
      },
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/register",
        element: <RegisterPage />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPasswordPage />,
      },
      {
        path: "/reset-password",
        element: <ResetPasswordPage />,
      },
      {
        path: "/change-password",
        element: <ChangePasswordPage />,
      },
      {
        path: "/auth/callback",
        element: <AuthCallbackPage />,
      },
      {
        path: "/register/finish",
        element: <RegisterFinishPage />,
      },
    ],
  },
  {
    element: <TranscribingPage />,
    path: "/transcribing",
  },
  {
    element: <SharePage />,
    path: "/share/:token",
  },
  {
    element: <ImpersonatePage />,
    path: "/impersonate/:token",
  },
  {
    element: <ScribeButtonDemo />,
    path: "/dev/scribe-button",
  },
  {
    element: <TestLimitReachedPage />,
    path: "/billing/test-limit-reached",
  },
  {
    path: "/share/access-denied",
    element: <ShareAccessDeniedPage />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export { App };
